import * as types from '@/store/types.js'
import Media from '@/model/Media'
import {removeResource} from '@/store/helpers'

const state = {
  media: {},
  isLoading: false
}

// GETTERS
const getters = {
  [types.ALL_MEDIA_ITEMS]: state => state.media,
  [types.IS_LOADING_MEDIA_ITEMS]: state => state.isLoading
}

// ACTIONS
const actions = {
  [types.GET_ALL_MEDIA_ITEMS]: ({ commit }, value) => {
    commit(types.GET_ALL_MEDIA_ITEMS, value)
  },
  [types.ADD_MEDIA]: ({ commit }, value) => {
    commit(types.ADD_MEDIA, value)
  },
  [types.REMOVE_MEDIA]: ({ commit }, value) => {
    commit(types.REMOVE_MEDIA, value)
  },
  [types.UPDATE_MEDIA_URL]: ({ commit }, value) => {
    commit(types.UPDATE_MEDIA_URL, value)
  },
  [types.IS_LOADING_MEDIA_ITEMS]: ({ commit }, value) => {
    commit(types.IS_LOADING_MEDIA_ITEMS, value)
  }
}

// MUTATIONS
const mutations = {
  [types.GET_ALL_MEDIA_ITEMS] (state, value) {
    state.media = value
  },
  [types.ADD_MEDIA]: (state, value) => {
    state.media.data.unshift(value)
  },
  [types.REMOVE_MEDIA]: (state, value) => {
    removeResource(Media, value, state.media, 'media.index')
  },
  [types.UPDATE_MEDIA_URL]: (state, value) => {
    state.activeMedia.url = value
  },
  [types.IS_LOADING_MEDIA_ITEMS]: (state, value) => {
    state.isLoading = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/Media.js